import { atom } from 'recoil';
import { IConfigArea } from '../../../commons/types/config';

export const configAreaAtom = atom<IConfigArea[]>({
  key: 'configArea',
  default: [] as IConfigArea[],
}); 
